import type { ComponentType } from 'react';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import {
	releaseVersionRequest,
	releaseRedirectToCreateReleaseNotesStatus,
} from '../state/actions.tsx';
import {
	getName,
	isSaving as isSavingSelector,
	isInitiating,
	getOnCancelHandler,
	getUnresolvedIssuesCount,
	isReleaseDisabled,
	shouldRedirectToCreateReleaseNotes,
	shouldShowCreateReleaseNotesOption,
} from '../state/selectors.tsx';
import Content from './content/index.tsx';
import ReleaseVersionModal from './ReleaseModal.tsx';

export type StateProps = {
	readonly unresolvedIssuesCount: number;
	readonly isSaving: boolean;
	readonly isReleaseDisabled: boolean;
	readonly isInitiating: boolean;
	readonly name: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly Content: ComponentType<Record<any, any>>;
	readonly onCancel: (arg1: undefined) => void;
	readonly shouldShowCreateReleaseNotesOption: boolean;
	readonly shouldRedirectToCreateReleaseNotes: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type OwnProps = Record<any, any>;

export type DispatchProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly onRelease: (arg1: undefined) => any;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any) => ({
	unresolvedIssuesCount: getUnresolvedIssuesCount(state),
	isReleaseDisabled: isReleaseDisabled(state),
	name: getName(state),
	isSaving: isSavingSelector(state),
	isInitiating: isInitiating(state),
	onCancel: getOnCancelHandler(state),
	Content,
	shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes(state),
	shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption(state),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dispatcher = (dispatch: any) => ({
	onRelease: () => dispatch(releaseVersionRequest()),
	setRedirectToCreateReleaseNotesStatus: (value: boolean) =>
		dispatch(releaseRedirectToCreateReleaseNotesStatus(value)),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: any) => dispatcher(dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReleaseVersionModal);
